import { RouteConfig } from "vue-router";
import { UserState } from "@/store/modules/auth/interfaces";

export const skills_routes: RouteConfig = {
  path: "/skills",
  component: () => import("@/views/skills/SkillsWrapper.vue"),
  meta: {
    user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
  },
  children: [
    {
      path: "",
      redirect: {
        name: "skills-demand"
      }
    },
    // {
    //   path: "difference",
    //   name: "main-skills",
    //   component: () => import("@/views/modules/skills/SkillDifference.vue"),
    //   meta: {
    //     user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
    //   }
    // },
    {
      path: "demand",
      name: "skills-demand",
      component: () => import("@/views/skills/NewSkillDemand.vue"),
      meta: {
        name: "Demand",
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    },
    // {
    //   path: "new-demand",
    //   name: "skills-new-demand",
    //   component: () => import("@/views/modules/skills/SkillDemand.vue"),
    //   meta: {
    //     user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
    //   }
    // },
    // {/home/aslase/Projects/hcms-frontend/src/router/institute_routes.ts
    //   path: "supply",
    //   name: "skills-supply",
    //   component: () => import("@/views/modules/skills/SkillSupply.vue"),
    //   meta: {
    //     user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
    //   }
    // },
    {
      path: "supply",
      name: "skills-supply",
      component: () => import("@/views/skills/NewSkillSupply.vue"),
      meta: {
        name: "Supply",
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    },
    {
      path: "error",
      name: "skill-error",
      component: () => import("@/views/ErrorPage.vue"),
      meta: {
        user_state: [UserState.RECRUITER, UserState.RECRUITER_ADMIN]
      }
    }
  ]
};
